import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import NavBar from '../../common/NavBar';
import Footer from '../../common/Footer';
import OwnerMenu from '../OwnerMenu';
import GuestMenu from '../../guests/GuestMenu';
import { useBookings } from './hooks/useBookings';
import BookingsTab from './BookingsTab';
import ReportsTab from './ReportsTab';
import OccupancyTab from './OccupancyTab';
import ProfitTab from './ProfitTab';

const BookingManagement = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('bookings');
  const bookingData = useBookings();

  if (!bookingData.userGroup) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      {bookingData.userGroup === "Owners" ? <OwnerMenu /> : <GuestMenu />}
      
      <div className="flex flex-col items-center mt-16">
        {/* Main Title */}
        <h1 className="text-3xl font-bold mb-8">{t("booking_management")}</h1>
        
        {/* Tabs Navigation */}
        <div className="w-full max-w-6xl mb-8">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              <button
                onClick={() => setActiveTab('bookings')}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'bookings'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {t("bookings")}
              </button>
              <button
                onClick={() => setActiveTab('reports')}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'reports'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {t("reports")}
              </button>
              <button
                onClick={() => setActiveTab('occupancy')}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'occupancy'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {t("occupancy_rates")}
              </button>
              <button
                onClick={() => setActiveTab('profit')}
                className={`py-2 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'profit'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {t("yearly_profit")}
              </button>
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="w-full max-w-6xl">
          {activeTab === 'bookings' && <BookingsTab {...bookingData} />}
          {activeTab === 'reports' && <ReportsTab {...bookingData} />}
          {activeTab === 'occupancy' && <OccupancyTab {...bookingData} />}
          {activeTab === 'profit' && <ProfitTab {...bookingData} />}
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default BookingManagement;